<template>
  <bg-badge
    :color="payinStatusColorAndIcon[status].badgeColor"
    :size="badgeSize"
  >
    <bg-icon
      v-if="payinStatusColorAndIcon[status].icon"
      :size="iconSize"
      :name="payinStatusColorAndIcon[status].icon"
      :color="payinStatusColorAndIcon[status].textColor"
      :class="isBadgeSizeMd ? '' : 'payins-status-bagde__icon--small'"
    />
    <bg-text
      type="label"
      weight="semi-bold"
      class="payins-status-bagde__text"
      :color="payinStatusColorAndIcon[status].textColor"
    >
      {{ payinStatusName[status] }}
    </bg-text>
  </bg-badge>
</template>

<script setup>
import { BgIcon, BgBadge, BgText } from '@transfeeradev/bridge';
import { computed } from 'vue';

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  badgeSize: {
    type: String,
    default: 'sm'
  },
  iconSize: {
    type: String,
    default: 'sm'
  }
});

const isBadgeSizeMd = computed(() => props.badgeSize === 'md');

const payinStatusColorAndIcon = computed(() => {
  return {
    received: { textColor: 'green-semi-dark', badgeColor: 'green-light', icon: 'check', width: '8px' },
    pending: { textColor: 'yellow-semi-dark', badgeColor: 'yellow-light', icon: 'clock', width: '10px' },
    canceled: { textColor: 'grey-semi-dark', badgeColor: 'grey-light', icon: 'cancel', width: '10px' },
    refunded: { textColor: 'blue-semi-dark', badgeColor: 'blue-light', icon: 'back-arrow', width: '10px' },
    partially_refunded: { textColor: 'blue-semi-dark', badgeColor: 'blue-light', icon: 'back-arrow', width: '10px' },
    rejected: { textColor: 'blue-semi-dark', badgeColor: 'blue-light', icon: 'back-arrow', width: '10px' },
    refunding: { textColor: 'blue-semi-dark', badgeColor: 'blue-light', icon: 'back-arrow', width: '10px' },
    expired: { textColor: 'grey-semi-dark', badgeColor: 'grey-light', icon: 'info', width: '8px' },
    active: { textColor: 'green-semi-dark', badgeColor: 'green-light', width: '8px' },
    authorized: { textColor: 'green-semi-dark', badgeColor: 'green-light', icon: 'calendar_today', width: '10px' },
    unauthorized: { textColor: 'red-semi-dark', badgeColor: 'red-light', icon: 'credit-score', width: '16px' },
    blocked: { textColor: 'grey-semi-dark', badgeColor: 'grey-light', icon: 'shield', width: '10px' }
  };
});

const payinStatusName = computed(() => {
  return {
    received: 'Recebido',
    pending: 'Pendente',
    canceled: 'Cancelado',
    refunded: 'Devolvido',
    partially_refunded: 'Devolvido',
    rejected: 'Processando',
    refunding: 'Processando',
    expired: 'Expirado',
    active: 'Ativo',
    authorized: 'A receber',
    unauthorized: 'Negado',
    blocked: 'Bloqueado'
  };
});
</script>

<style scoped>
.payins-status-bagde__text {
  margin-left: var(--bg-spacing-2x-sm);
}

.payins-status-bagde__icon--small {
  width: v-bind(payinStatusColorAndIcon[status].width);
}
</style>
